import { Card, CardContent, CardHeader, Dialog, IconButton, Paper, Typography, withStyles } from "@material-ui/core"
import { connect, useDispatch } from "react-redux"
import React, { Component, useEffect, useState, useRef } from "react";
import baseStyle from '../../../styles/dashboard';
import { Close } from "@material-ui/icons";
import { addStoryToStudent, getBookShareUsers, getStaffUser, downloadBook, getBooksForStudent, getBookshareRequestedBooks } from "../../../redux/actions";
import BookShareCredentialsLogin from "../Student/BookShareCredentialsLogin";
import BookShareUserTable from "../../../Social/NetflixSlider/BookShareUserTable";
import { CLEAR_IMPORTED_BOOK, RESET_IMPORT_MODAL, SAVE_IMPORTED_BOOK } from "../../../redux/constants";
import LoadingModal from '../Student/LoadingModal';
import BookShareRequestModal from "./BookShareRequestModal";
import BookShareRestrictedModal from "./BookShareRestrictedModal";



function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  })
  return ref.current;
}

const ReImportBooks = (props) => {
  const [imported, setImported] = useState([]);
  const [loginRequired, setLoginRequired] = useState(false);
  const [showImportMessage, setShowImportMessage] = useState(false);
  const [importErrorMessage, setImportErrorMessage] = useState("");
  const [importSlide, setImportSlide] = useState(null);
  const [messageLink, setMessageLink] = useState("");
  const [bookShareUser, setBookShareUser] = useState([]);
  const [showStudent, setShowStudent] = useState(false);
  const [showSelectedRow, setShowSelectedRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showRestrictedModal, setShowRestrictedModal] = useState(false);
  const prevProps = usePrevious(props);

  // Helper function to extract message string whether it's nested or not
  const getMessageString = (messageObj) => {
    if (typeof messageObj === 'string') {
      return messageObj;
    }
    if (messageObj && typeof messageObj === 'object' && messageObj.message) {
      return messageObj.message;
    }
    return null;
  };

  const {
    user,
    handleUnmount,
    booksImport,
    student,
    storyId,
    handleImportedBook,
    story,
    bookShareList,
    searchFromBookShare,
  } = props;
  const dispatch = useDispatch();

  const closeModal = () => {
    setOpenModal(false);
    setModalType("");
  };

  useEffect(() => {
    setImportSlide(story);
    if (booksImport && booksImport.bookSearchToggle) {
      const filteredBook =
        bookShareList && bookShareList.filter((book) => book.id === story.id);
      if (
        filteredBook &&
        filteredBook.length > 0 &&
        filteredBook[0].storyDataId &&
        filteredBook[0].storyDataId != null
      ) {
        dispatch(addStoryToStudent(storyId, filteredBook[0].storyDataId));
      } else {
        filteredBook &&
          dispatch(downloadBook(story.id, storyId, filteredBook[0]));
      }
    } else {
      if (searchFromBookShare) {
        const filteredBook =
          bookShareList && bookShareList.filter((book) => book.id === story.id);
        if (
          filteredBook &&
          filteredBook.length > 0 &&
          filteredBook[0].storyDataId &&
          filteredBook[0].storyDataId != null
        ) {
          dispatch(addStoryToStudent(storyId, filteredBook[0].storyDataId));
        } else {
          filteredBook &&
            dispatch(downloadBook(story.id, storyId, filteredBook[0]));
        }
      } else {
        dispatch(addStoryToStudent(storyId, story.id));
      }
    }
  }, []);

  useEffect(() => {
    if (
      props.bookShareUsers.bookshareUserAdded &&
      (!prevProps || !prevProps.bookShareUsers.bookshareUserAdded)
    ) {
      if (props.storyId && importSlide) {
        let id = props.story.storyDataId || props.story.id;
        dispatch(addStoryToStudent(props.storyId, id));
      }
    } else {
      if (
        props.bookShareUsers &&
        (!prevProps || props.bookShareUsers !== prevProps.bookShareUsers)
      ) {
        if (props.bookShareUsers.data !== undefined) {
          setBookShareUser(props.bookShareUsers.data);
        }
      }
      if (
        props.booksImport &&
        (!prevProps || prevProps.booksImport !== props.booksImport)
      ) {
        const messageString = getMessageString(props.booksImport.message);
        
        if (messageString === "Cannot retrieve organization members") {
          setShowImportMessage(true);
          setImportErrorMessage(
            "There was an error when trying to request this book from Bookshare, this could either be:\n" +
              "\n" +
              "1). That the book you are requesting is not available in your region\n" +
              "\n" +
              "Or\n" +
              "\n" +
              "2). Your Bookshare account is not active or has not been fully set up.  Please login at https://www.bookshare.org/cms/ to verify that your account is setup properly\n" +
              "\n" +
              "If you continue to experience this issue, please contact support@ObjectiveEd.com\n"
          );
          setLoginRequired(false);
          setMessageLink("");
        } else if (
          messageString === "User is Not Logged into bookshare" ||
          messageString === "Authentication has expired"
        ) {
          setShowImportMessage(false);
          setImportErrorMessage("");
          setLoginRequired(true);
          setMessageLink("");
          dispatch({ type: RESET_IMPORT_MODAL });
        } else if (messageString === "Cannot find Student Match") {
          setShowImportMessage(true);
          setImportErrorMessage(
            "We can't find this student in your Bookshare account, please check the list for the correct student and press the (+) icon."
          );
          setLoginRequired(false);
          setMessageLink("https://www.bookshare.org/orgAccountMembers");
          dispatch({ type: RESET_IMPORT_MODAL });
          if (!bookShareUser || bookShareUser.length === 0) {
            dispatch(getBookShareUsers());
          }
        } else if (messageString === "Too Many Requests") {
          setLoginRequired(false);
          setShowRequestModal(true);
          props.closeLoading();
          dispatch({ type: RESET_IMPORT_MODAL });
        } else if (messageString === "Restricted Title") {
          setLoginRequired(false);
          setShowRestrictedModal(true);
          props.closeLoading();
          dispatch({ type: RESET_IMPORT_MODAL });
        } else if (messageString === "Cannot Load Via Previous Attempt") {
          setShowImportMessage(true);
          setImportErrorMessage(
            "Oops! It seems like ObjectiveEd can't work with this book because it contains text embedded within images. ObjectiveEd works best with books with clear text, making it easier for our Buddy Reading feature to assist you.  Please try another book; we will happily prepare it for you."
          );
          setLoginRequired(false);
          dispatch({ type: RESET_IMPORT_MODAL });
          if (!bookShareUser || bookShareUser.length === 0) {
            dispatch(getBookShareUsers());
          }
        }
        if (props.booksImport.studentBookImported) {
          props.handleImportedBook(importSlide);
          props.handleUnmount();
          if (!props.booksImport.bookSearchToggle) {
            dispatch({
              type: SAVE_IMPORTED_BOOK,
              payload: importSlide,
            });
          }
          setShowImportMessage(false);
          dispatch({ type: RESET_IMPORT_MODAL });
          dispatch(getBooksForStudent(props.storyId));
          dispatch(getBookshareRequestedBooks(props.storyId));
          props.closeLoading();
        }
      }
      if (
        props.importBooks &&
        (!prevProps || props.importBooks !== prevProps.importBooks) &&
        props.importBooks.bookImported
      ) {
        dispatch({ type: CLEAR_IMPORTED_BOOK });
        dispatch(getStaffUser());
        if (props.booksImport && props.booksImport.bookSearchToggle) {
          const filteredBook =
            props.bookShareList &&
            props.bookShareList.filter((book) => book.id === props.story.id);
          if (
            filteredBook &&
            filteredBook.length > 0 &&
            filteredBook[0].storyDataId &&
            filteredBook[0].storyDataId != null
          ) {
            dispatch(
              addStoryToStudent(props.storyId, filteredBook[0].storyDataId)
            );
          } else {
            filteredBook &&
              dispatch(
                downloadBook(props.story.id, props.storyId, filteredBook[0])
              );
          }
        } else {
          if (props.storyId && importSlide) {
            let id = props.story.storyDataId || props.story.id;
            dispatch(addStoryToStudent(props.storyId, id));
          }
        }
      }
    }
  }, [props, dispatch, importSlide, bookShareUser]);

  const closeLoginModal = () => {
    setLoginRequired(false);
    if (user && !user.hasBookShareCredentials) {
      handleUnmount();
    }
  };

  const closeImportMessageModal = () => {
    setShowImportMessage(false);
    handleUnmount();
  };

  const addStudent = () => {
    setShowStudent(true);
  };

  const handleStudentWizardClose = () => {
    setShowStudent(false);
  };

  const handleRequestClose = () => {
    setShowRequestModal(false);
  };

  const handleRestrictedClose = () => {
    setShowRestrictedModal(false);
  };

  return (
    <>
      {loginRequired ? (
        <BookShareCredentialsLogin
          openLoading={loginRequired}
          exitFunc={closeLoginModal}
        />
      ) : null}
      <Dialog
        open={showImportMessage}
        maxWidth="lg"
        onClose={() => closeImportMessageModal()}
      >
        <Paper className="list">
          <Card aria-label="Message">
            <CardHeader
              style={{ backgroundColor: "#00729b", marginBottom: "20px" }}
              action={
                <IconButton onClick={closeImportMessageModal}>
                  <Close />
                </IconButton>
              }
              title={
                <Typography variant="h5" className="header">
                  {bookShareUser
                    ? "Link Student"
                    : "Something went wrong"}
                </Typography>
              }
            ></CardHeader>
            <CardContent
              className="synopsis_description"
              style={{ textAlign: "center", fontFamily: "Calibri, sans-serif" }}
            >
              <div style={{ textAlign: "center" }}>
                {importErrorMessage}
                <br />{" "}
              </div>

              {messageLink &&
              messageLink.length > 0 &&
              bookShareUser? (
                <>
                  <br />
                  <BookShareUserTable
                    student={student}
                    storyId={storyId}
                    importSlide={importSlide}
                    closeImportMessageModal={closeImportMessageModal}
                    handleImportedBook={handleImportedBook}
                    handleUnmount={handleUnmount}
                    messageLink={messageLink}
                    showStudent={showStudent}
                    addStudent={addStudent}
                    handleStudentWizardClose={handleStudentWizardClose}
                  />
                </>
              ) : null}
            </CardContent>
          </Card>
        </Paper>
      </Dialog>
      {openModal && (
        <LoadingModal
          openLoading={openModal}
          type={modalType}
          exitFunc={closeModal}
        />
      )}
      {showRequestModal && (
        <BookShareRequestModal
          open={showRequestModal}
          close={handleRequestClose}
        />
      )}
      {showRestrictedModal && (
        <BookShareRestrictedModal
          open={showRestrictedModal}
          close={handleRestrictedClose}
        />
      )}
    </>
  );
};

// appears to be legacy code that was converted above.
// class ImportBooks extends Component {

//     constructor(props) {
//         super(props);

//         this.state = {
//             imported: [],
//             loginRequired: false,
//             showImportMessage: false,
//             importErrorMessage: '',
//             importSlide: null,
//             messageLink: '',
//             bookShareUser: [],
//             showStudent: false,
//             showSelectedRow: null,
//             openModal: false,
//             modalType: '',
//             showRequestModal: false
//         }
//     }

//     closeModal = () => {
//         this.setState({ openModal: false, modalType: '' })
//     }

//     componentDidMount() {
//         if (this.props.booksImport && this.props.booksImport.bookSearchToggle) {
//             const filteredBook = this.props.bookShareList && this.props.bookShareList.filter((book) => book.id == this.props.story.id);
//             if (filteredBook && filteredBook[0].storyDataId && filteredBook[0].storyDataId != null)
//                 this.props.dispatch(addStoryToStudent(this.props.storyId, filteredBook[0].storyDataId));
//             else
//                 filteredBook && this.props.dispatch(downloadBook(this.props.story.id, this.props.storyId, filteredBook[0]));
//         }
//         else {
//             if (this.props.searchFromBookShare) {
//                 const filteredBook = this.props.bookShareList && this.props.bookShareList.filter((book) => book.id == this.props.story.id);
//                 if (filteredBook && filteredBook[0].storyDataId && filteredBook[0].storyDataId != null)
//                     this.props.dispatch(addStoryToStudent(this.props.storyId, filteredBook[0].storyDataId));
//                 else
//                     filteredBook && this.props.dispatch(downloadBook(this.props.story.id, this.props.storyId, filteredBook[0]));
//             }
//             else
//                 this.props.dispatch(addStoryToStudent(this.props.storyId, this.props.story.id));
//         }
//         this.setState({
//             importSlide: this.props.story
//         });
//     }
//     componentDidUpdate(prevProps) {
//       if (this.props.bookShareUsers.bookshareUserAdded && !prevProps.bookShareUsers.bookshareUserAdded) {
//         if (this.props.storyId && this.state.importSlide) {
//           let id = this.props.story.storyDataId || this.props.story.id;
//           this.props.dispatch(addStoryToStudent(this.props.storyId, id));
//         }
//       } else {
//         if (this.props.bookShareUsers && this.props.bookShareUsers !== prevProps.bookShareUsers) {
//             this.setState({
//                 bookShareUser: this.props.bookShareUsers.data
//             })
//         }
//         if (prevProps.booksImport != this.props.booksImport && this.props.booksImport && this.props.booksImport.message === "Cannot retrieve organization members") {
//             this.setState({
//                 showImportMessage: true,
//                 importErrorMessage: "There was an error when trying to request this book from Bookshare, this could either be:\n" +
//                     "\n" +
//                     "1). That the book you are requesting is not available in your region\n" +
//                     "\n" +
//                     "Or\n" +
//                     "\n" +
//                     "2). Your Bookshare account is not active or has not been fully set up.  Please login at https://www.bookshare.org/cms/ to verify that your account is setup properly\n" +
//                     "\n" +
//                     "If you continue to experience this issue, please contact support@ObjectiveEd.com\n",
//                 loginRequired: false,
//                 messageLink: ''
//             });
//             this.props.dispatch({
//                 type: RESET_IMPORT_MODAL
//             });
//         }
//         else if ((prevProps.booksImport != this.props.booksImport &&
//             (this.props.booksImport.message === "User is Not Logged into bookshare"
//                 || this.props.booksImport.message === "Authentication has expired"))
//         ) {
//             this.setState({
//                 showImportMessage: false,
//                 importErrorMessage: "",
//                 loginRequired: true,
//                 messageLink: ''
//             });
//             this.props.dispatch({
//                 type: RESET_IMPORT_MODAL
//             });
//         }
//         else if (this.props.booksImport && prevProps.booksImport != this.props.booksImport
//             && this.props.booksImport.message === "Cannot find Student Match") {

//             this.setState({
//                 showImportMessage: true,
//                 importErrorMessage: "We can't find this student in your Bookshare account, please check the list for the correct student and press the (+) icon.",
//                 loginRequired: false,
//                 messageLink: 'https://www.bookshare.org/orgAccountMembers'
//             })
//             this.props.dispatch({
//                 type: RESET_IMPORT_MODAL
//             });
//             if (this.state.bookShareUser.length == 0)
//                 this.props.dispatch(getBookShareUsers());
//         }
//         else if (this.props.booksImport && prevProps.booksImport != this.props.booksImport
//             && this.props.booksImport.message === "Too Many Requests") {
//             this.setState({
//                 loginRequired: false,
//                 showRequestModal: true
//             });
//             this.props.closeLoading();
//             this.props.dispatch({
//                 type: RESET_IMPORT_MODAL
//             });
//         }
//         else  if (this.props.booksImport && prevProps.booksImport != this.props.booksImport
//             && this.props.booksImport.message === "Restricted Title") {
//             this.setState({
//                 loginRequired: false,
//                 showRestrictedModal: true
//             });
//             this.props.closeLoading();
//             this.props.dispatch({
//                 type: RESET_IMPORT_MODAL
//             });
//         }
//         if (this.props.booksImport && prevProps.booksImport != this.props.booksImport && this.props.booksImport.studentBookImported) {
//             // After the book is successfully imported
//             this.props.handleImportedBook(this.state.importSlide);
//             this.props.handleUnmount();
//             if (this.props.booksImport && !this.props.booksImport.bookSearchToggle)
//                 this.props.dispatch({
//                     type: SAVE_IMPORTED_BOOK,
//                     payload: this.state.importSlide
//                 });
//             this.setState({ showImportMessage: false });
//             this.props.dispatch({ type: RESET_IMPORT_MODAL });
//             this.props.dispatch(getBooksForStudent(this.props.storyId));
//             this.props.dispatch(getBookshareRequestedBooks(this.props.storyId));
//             this.props.closeLoading();
//         }

//         if (this.props.importBooks != prevProps.importBooks && this.props.importBooks && this.props.importBooks.bookImported === true) {
//             // this.setState({
//             //     loginRequired: false
//             // })
//             this.props.dispatch({ type: CLEAR_IMPORTED_BOOK })
//             this.props.dispatch(getStaffUser());
//             if (this.props.booksImport && this.props.booksImport.bookSearchToggle) {
//                 const filteredBook = this.props.bookShareList && this.props.bookShareList.filter((book) => book.id == this.props.story.id);
//                 if (filteredBook && filteredBook[0].storyDataId && filteredBook[0].storyDataId != null)
//                     this.props.dispatch(addStoryToStudent(this.props.storyId, filteredBook[0].storyDataId));
//                 else
//                     filteredBook && this.props.dispatch(downloadBook(this.props.story.id, this.props.storyId, filteredBook[0]));

//             }
//             else {
//                 if (this.props.storyId && this.state.importSlide) {
//                     let id = this.props.story.storyDataId || this.props.story.id;
//                     this.props.dispatch(addStoryToStudent(this.props.storyId, id));
//                 }
//             }
//         }
//       }
//     }
//     closeLoginModal = () => {
//         this.setState({
//             loginRequired: false
//         });
//         if (this.props.user && this.props.user.hasBookShareCredentials == false)
//             this.props.handleUnmount();
//     }
//     closeImportMessageModal = () => {

//         this.setState({
//             showImportMessage: false
//         });
//         this.props.handleUnmount();
//     }
//     addStudent = () => {
//         this.setState({
//             showStudent: true
//         })
//     }
//     handleStudentWizardClose = () => {
//         this.setState({
//             showStudent: false
//         })
//     }
//     handleRequestClose = () => {
//         this.setState({
//             showRequestModal: false
//         })
//     }
//     handleRestrictedClose = () => {
//         this.setState({
//             showRestrictedModal: false
//         })
//     }
//     render() {
//         const { booksImport, student } = this.props;
//         const { loginRequired, showImportMessage, importErrorMessage, messageLink, bookShareUser, importSlide } = this.state;
//         return (
//             <>
//                 {
//                     (loginRequired)
//                         ? <BookShareCredentialsLogin
//                             openLoading={loginRequired}
//                             exitFunc={this.closeLoginModal} /> : null
//                 }
//                 <Dialog open={showImportMessage} maxWidth='lg' onClose={() => this.closeImportMessageModal()}>
//                     <Paper className='list'>
//                         <Card aria-label="Message" >
//                             <CardHeader style={{ backgroundColor: '#00729b', marginBottom: '20px' }} action={
//                                 <IconButton onClick={this.closeImportMessageModal}>
//                                     <Close />
//                                 </IconButton>}
//                                 title={<Typography variant='h5' className='header'>{bookShareUser && bookShareUser.length > 0 ? "Link Student" : "Something went wrong"}</Typography>}
//                             >
//                             </CardHeader>
//                             <CardContent className='synopsis_description' style={{ textAlign: 'center', fontFamily: "Calibri, sans-serif" }} >
//                                 <div style={{ textAlign: 'center' }} >{importErrorMessage}
//                                     <br /> </div>

//                                 {messageLink && messageLink.length > 0 && bookShareUser && bookShareUser.length > 0
//                                     ?
//                                     <>
//                                         <br />
//                                         <BookShareUserTable student={student}
//                                             storyId={this.props.storyId}
//                                             importSlide={importSlide}
//                                             closeImportMessageModal={this.closeImportMessageModal}
//                                             handleImportedBook={this.props.handleImportedBook}
//                                             handleUnmount={this.props.handleUnmount}
//                                             messageLink={messageLink}
//                                             showStudent={this.state.showStudent}
//                                             addStudent={this.addStudent}
//                                             handleStudentWizardClose={this.handleStudentWizardClose}
//           />
//                                     </>
//                                     : null
//                                 }
//                             </CardContent>
//                         </Card>
//                     </Paper>
//                 </Dialog>
//                 {
//                     this.state.openModal &&
//                     <LoadingModal openLoading={this.state.openModal} type={this.state.modalType} exitFunc={this.closeModal} />
//                 }
//                 {
//                     this.state.showRequestModal &&
//                     <BookShareRequestModal open={this.state.showRequestModal} close={this.handleRequestClose} />
//                 }
//                 {
//                  this.state.showRestrictedModal &&
//                     <BookShareRestrictedModal open={this.state.showRestrictedModal} close={this.handleRestrictedClose} />
//                 }
//             </>
//         )
//     }
// }

const mapStateToProps = ({ shared: { user }, platform: { booksImport, importBooks, bookShareUsers, student, bookShareList } }) => {
    return {
        user,
        booksImport,
        importBooks,
        bookShareUsers,
        student,
        bookShareList
    }
};
export default connect(mapStateToProps)(withStyles(baseStyle)(ReImportBooks));